:host {
  color: var(--pdt-color-text-bold);
  font-size: var(--pdt-text-body-sm-font-size);
  font-weight: var(--pdt-text-body-md-bold-font-weight);
  line-height: var(--pdt-text-body-sm-line-height);
  user-select: none;
  display: flex;
  align-items: center;
  padding: var(--pdt-space-75) var(--pdt-space-100);
}
